import { trans } from '@lingoda/i18n';
import { Box, GradientButton } from '@lingoda/ui';
import { subscriptionsStorePath } from '@lingoda/router';
import { LinkTab } from './LinkTab';
import type { TabCommonProps } from './types';

export const Prices = (props: TabCommonProps) => (
    <LinkTab
        to={subscriptionsStorePath()}
        track="Prices"
        label={
            <Box>
                <GradientButton>{trans('navigation.prices', {}, 'public-common')}</GradientButton>
            </Box>
        }
        {...props}
    />
);
